export const state = {
  campaign: null,
  campaignPerformance: null,
  brandVisibility: null,
  influencerInsights: null,
  campaignSentiment: null,
  recommendations: null,
  loadingPages: false,
}

export const getters = {
  campaign: (state) => state.campaign,
  campaignPerformance: (state) => state.campaignPerformance,
  brandVisibility: (state) => state.brandVisibility,
  influencerInsights: (state) => state.influencerInsights,
  campaignSentiment: (state) => state.campaignSentiment,
  recommendations: (state) => state.recommendations,
  loadingPages: (state) => state.loadingPages,
}

export const mutations = {
  SET_CAMPAIGN(state, payload) {
    state.campaign = payload
  },
  SET_CAMPAIGN_PERFORMANCE(state, payload) {
    state.campaignPerformance = payload
  },
  SET_BRAND_VISIBILITY(state, payload) {
    state.brandVisibility = payload
  },
  SET_INFLUENCER_INSIGHTS(state, payload) {
    state.influencerInsights = payload
  },
  SET_CAMPAIGN_SENTIMENT(state, payload) {
    state.campaignSentiment = payload
  },
  SET_RECOMMENDATIONS(state, payload) {
    state.recommendations = payload
  },
  SET_LOADING_PAGES(state, payload) {
    state.loadingPages = payload
  },
  RESET(state) {
    state.campaign = null
    state.campaignPerformance = null
    state.brandVisibility = null
    state.influencerInsights = null
    state.campaignSentiment = null
    state.recommendations = null
    state.loadingPages = false
  },
}
